export enum Frequency {
    DAYS="DAYS",
    MONTHS="MONTHS",
    WEEKS="WEEKS",
    HOURS="HOURS"
}